import styles from './CVSectionHeader.module.css';

function CVSectionHeader({ title }) {
    return <div className={styles['cv-section-header']}>{title}</div>;
}

export default CVSectionHeader;
